export var LayoutBlockType;
(function (LayoutBlockType) {
    LayoutBlockType["LAYOUT_CONTAINER"] = "layout::container";
})(LayoutBlockType || (LayoutBlockType = {}));
export var ContainerLayoutType;
(function (ContainerLayoutType) {
    ContainerLayoutType["COLUMNS"] = "columns";
    ContainerLayoutType["GRID"] = "grid";
})(ContainerLayoutType || (ContainerLayoutType = {}));
